import './index.css';
import 'semantic-ui-css/semantic.min.css'
import App from './pages/App/App';

import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop.jsx";

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop/>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
